import {BigRoad} from './big-road.js';

class SharedBigRoad extends BigRoad {

    constructor(row, column, roundResults) {
        super(row, column, roundResults);
    }

    get rawArray() {
        return this.array;
    }
}

export {SharedBigRoad};
